import React from 'react';

import ToolboxButton from './ToolboxButton';
import Toolbox from './Toolbox';
import FaultTreeTransferGateVertex from '../../../../../mxGraph/HCLTreeNode/FaultTreeNode/FaultTreeTransferGateNode/FaultTreeTransferGateVertex';
import FaultTreeTransferGateVertexValue from '../../../../../mxGraph/HCLTreeNode/FaultTreeNode/FaultTreeTransferGateNode/FaultTreeTransferGateVertexValue';
import { TreeNames } from './TreeDictionaries';
import HCLTreeMxGraph from '../../../../../mxGraph/HCLTreeMxGraph/HCLTreeMxGraph';
// @ts-ignore
import HCLTreeVertex from '../../../../../mxGraph/HCLTreeNode/HCLTreeVertex';
import NewHCLModelButton from './NewHCLModelButton';
import HCLModelTypes, { HCLModelTagTypeKey } from '../../../HCLModelTypes';

interface Props {
  graph: HCLTreeMxGraph;
  treeName: TreeNames;
  saving: boolean;
}

class TransferGatesToolbox extends React.Component<Props> {
  private addVertexWithUniqueKey = (vertex: any, vertexValue: any) => {
    const { graph } = this.props;
    const model = graph.getModel();
    const selectedCells = graph.getSelectionCells() as HCLTreeVertex[];
    try {
      model.beginUpdate();
      const newCell = graph.addVertexWithUniqueKey(new vertex(null, new vertexValue()));
      selectedCells.forEach((selectedCell) => {
        if (selectedCell instanceof HCLTreeVertex) {
          selectedCell.onRequestConnectChildVertex(newCell);
        }
      });
    } catch (e) {
      console.error(e);
    } finally {
      graph.applyDefaultLayout();
      model.endUpdate();
    }
  };

  private handleFaultTreeTransferGateClick = (e: React.MouseEvent<HTMLElement>) => {
    this.addVertexWithUniqueKey(FaultTreeTransferGateVertex, FaultTreeTransferGateVertexValue);
  };

  /**
   * @throws An error if treeName is not in {@link TreeNames}
   */
  render() {
    const { saving, treeName, graph } = this.props;

    if (treeName !== TreeNames.FAULT_TREE) {
      return null;
    }

    const items = [
      <NewHCLModelButton
        disabled={saving}
        graph={graph}
        key={HCLModelTypes[HCLModelTagTypeKey.PROJECT].tag}
        type={HCLModelTypes[HCLModelTagTypeKey.PROJECT]}
      />,
      <NewHCLModelButton
        disabled={saving}
        graph={graph}
        key={HCLModelTypes[HCLModelTagTypeKey.SUBSYSTEM].tag}
        type={HCLModelTypes[HCLModelTagTypeKey.SUBSYSTEM]}
      />,
      <NewHCLModelButton
        disabled={saving}
        graph={graph}
        key={HCLModelTypes[HCLModelTagTypeKey.COMPONENT].tag}
        type={HCLModelTypes[HCLModelTagTypeKey.COMPONENT]}
      />,
      <NewHCLModelButton
        disabled={saving}
        graph={graph}
        key={HCLModelTypes[HCLModelTagTypeKey.TRANSFER_GATE].tag}
        type={HCLModelTypes[HCLModelTagTypeKey.TRANSFER_GATE]}
      />,
    ];

    return <Toolbox items={items} />;
  }
}

export default TransferGatesToolbox;
